<template>
  <el-form-item
    :label="label"
    class="callsign"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="callsign"
      type="text"
      :clearable="true"
      :maxlength="7"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '便名'
    },
    prop: {
      type: String,
      default: 'callsign'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角英数（最大7文字）'
    }
  },
  computed: {
    callsign: {
      get () {
        return this.value
      },
      set (callsign) {
        this.$emit('input', callsign.toUpperCase())
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          rules.push(this.validatorHalfUCaseAlphabetNumber(this.label, 'blur'))
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-form-item {
  &.callsign {
    .el-form-item__content {
        width: 12em;
    }
  }
}
</style>
